var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-toast",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.title.length > 0,
          expression: "title.length > 0",
        },
      ],
      attrs: {
        solid: "",
        "auto-hide-delay": "30000",
        "toast-class": _vm.toastClass,
        "header-class": _vm.headerClass,
        toaster: _vm.position,
        "no-auto-hide": _vm.noAutoHide,
        id: _vm.id,
        to: _vm.link,
      },
      on: {
        hide: _vm.clearDateTimeInterval,
        hidden: _vm.onHidden,
        show: _vm.onShow,
        shown: _vm.autoClose,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "notification-body-wrapper",
          on: { click: _vm.onNotificationClick },
        },
        [
          _c("div", { staticClass: "d-flex flex-row align-items-center" }, [
            _c(
              "div",
              {
                staticClass: "notification-icon",
                class: _vm.notificationIconClasses,
                on: { click: _vm.toInbox },
              },
              [
                _vm.id === "system" ? _c("system-update-icon") : _vm._e(),
                _vm.id === "sms" ? _c("sms-icon") : _vm._e(),
                _vm.id === "call" ? _c("call-icon") : _vm._e(),
                _vm.id === "voicemail" ? _c("voicemail-icon") : _vm._e(),
                _vm.id === "mention" ? _c("mention-icon") : _vm._e(),
                _vm.id === "reminder" ? _c("reminder-icon") : _vm._e(),
                _vm.isCall ? _c("call-incoming-icon") : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "notification-details",
                class: _vm.id !== "incomingCall" ? "w-100" : "flex-grow-1",
                on: { click: _vm.toInbox },
              },
              [
                _vm.getSource
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-grow-1 align-items-baseline w-100",
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "mr-auto text-white pr-1 text-sm" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getSource) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-grow-1 align-items-baseline w-100",
                  },
                  [
                    _c(
                      "strong",
                      { staticClass: "mr-auto text-white title pr-1" },
                      [
                        _vm._v(
                          "\n            " + _vm._s(_vm.title) + "\n          "
                        ),
                      ]
                    ),
                    !_vm.isCall
                      ? _c(
                          "small",
                          { staticClass: "mr-2 text-grey-82 time text-nowrap" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.runningDateTime) +
                                "\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm.location
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-grow-1 align-items-baseline w-100",
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "mr-auto text-white pr-1 text-sm" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.location) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "text-grey-81 message-body text-break d-flex w-100",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-grow-1 d-flex align-items-center w-100",
                      },
                      [
                        _vm.messageIcon
                          ? _c(_vm.messageIcon, {
                              tag: "component",
                              staticClass: "message-icon mr-1",
                            })
                          : _vm._e(),
                        !_vm.isCall && _vm.message
                          ? _c("span", {
                              staticClass: "message-text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.sanitizeHtml(
                                    _vm.$options.filters.nl2br(
                                      _vm.message,
                                      false
                                    )
                                  )
                                ),
                              },
                            })
                          : _vm._e(),
                        _vm.id === "sms" && _vm.attachment && !_vm.message
                          ? _c("span", { staticClass: "message-text" }, [
                              _vm._v(
                                "\n              Inbound MMS\n            "
                              ),
                            ])
                          : _vm.isCall && _vm.campaignName && _vm.ringGroupName
                          ? _c(
                              "div",
                              {
                                staticClass: "message-text row has-ring-group",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "campaign-wrapper col-5" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "campaign-name" },
                                      [_vm._v(_vm._s(_vm.campaignName))]
                                    ),
                                  ]
                                ),
                                _c("div", { staticClass: "flex-grow-1" }, [
                                  _vm._v(">"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "ring-group-wrapper col-5" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ring-group-name" },
                                      [_vm._v(_vm._s(_vm.ringGroupName))]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm.isCall && _vm.campaignName && !_vm.ringGroupName
                          ? _c("span", { staticClass: "message-text d-flex" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.campaignName) +
                                  "\n            "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            ),
            _vm.shouldShowCallActions
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-center align-items-center call-actions",
                  },
                  [
                    _c(
                      "q-btn",
                      {
                        staticClass: "height-32 mr-2",
                        attrs: { ripple: "", round: "", "no-caps": "" },
                        on: { click: _vm.rejectCall },
                      },
                      [
                        _c("cancel-call-icon", {
                          attrs: { width: "32", height: "32" },
                        }),
                        _c(
                          "q-tooltip",
                          {
                            attrs: {
                              anchor: "top middle",
                              self: "bottom middle",
                            },
                          },
                          [_vm._v("\n            Decline\n          ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "q-btn",
                      {
                        staticClass: "height-32",
                        attrs: { ripple: "", round: "", "no-caps": "" },
                        on: { click: _vm.answerCall },
                      },
                      [
                        _c(
                          "q-tooltip",
                          {
                            attrs: {
                              anchor: "top middle",
                              self: "bottom middle",
                            },
                          },
                          [_vm._v("\n            Answer\n          ")]
                        ),
                        _c("accept-call-icon", {
                          attrs: { width: "32", height: "32" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }